import { Flame } from "lucide-react";
import CountdownTimer from "@/components/CountdownTimer";

export default function AnnouncementBar() {
  const msg = (
    <span className="inline-flex items-center gap-3 px-6">
      <Flame className="h-4 w-4 text-amber-300" />
      <span className="font-semibold tracking-wide">
        OFFRE DE PRÉPARATION HALLOWEEN — Stocks limités !
      </span>
      <span className="text-amber-200">
        Code <b className="font-mono-tech">FRISSON20</b> : -20% dès 25 € d'achat
      </span>
      <span className="text-amber-300">•</span>
    </span>
  );
  return (
    <div
      className="w-full bg-red-700 text-white text-xs sm:text-sm relative z-50"
      data-testid="announcement-bar"
    >
      <div className="flex items-center justify-between max-w-[1400px] mx-auto">
        <div className="flex-1 overflow-hidden whitespace-nowrap py-2">
          <div className="inline-flex animate-marquee">
            {msg}
            {msg}
            {msg}
            {msg}
          </div>
        </div>
        <div className="hidden lg:flex items-center gap-2 pr-6 pl-4 py-2 border-l border-white/20 shrink-0">
          <span className="uppercase text-[10px] tracking-widest opacity-80">Plus que</span>
          <CountdownTimer compact />
        </div>
      </div>
    </div>
  );
}
